module.exports = __webpack_public_path__ + "img/image 9.04b64a85.png";